import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { CallService } from '@nutrix/data-access-calls';

/**
 * Floating, draggable call widget. Mounted once in the authenticated shell so it
 * survives route navigation and the doctor can keep browsing during a call.
 * Shows the active/outbound-ringing call with mute, hang up and record controls.
 */
@Component({
  selector: 'nutrix-call-widget',
  standalone: true,
  imports: [CommonModule, DragDropModule, ButtonModule, TooltipModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './call-widget.component.html',
  styleUrl: './call-widget.component.css',
})
export class CallWidgetComponent {
  readonly call = inject(CallService);

  readonly visible = computed(() => {
    const p = this.call.phase();
    return p === 'ringing-out' || p === 'connecting' || p === 'active';
  });

  readonly statusLabel = computed(() => {
    switch (this.call.phase()) {
      case 'ringing-out':
        return 'Llamando…';
      case 'connecting':
        return 'Conectando…';
      case 'active':
        return this.call.elapsedLabel();
      default:
        return '';
    }
  });

  toggleMute(): void {
    this.call.toggleMute();
  }

  hangup(): void {
    void this.call.hangup();
  }
}
